/**
 * Sorts an array of tenant strings by their hierarchy levels.
 * The hierarchy is determined by the number of segments in the string,
 * which are separated by slashes ('/'). If two tenants have the same
 * number of segments, they are sorted lexicographically.
 *
 * @param {string[]} [tenants=[]] - An array of tenant strings to be sorted.
 * @returns {string[]} A new array of tenant strings sorted by hierarchy.
 */
export const sortTenantsByHierarchy = (tenants = []) => {
    return tenants
        .slice()
        .sort((a, b) => {
            const levelsA = a.split('/').length;
            const levelsB = b.split('/').length;

            if (levelsA !== levelsB) {
                return levelsA - levelsB;
            }

            return a.localeCompare(b);
        });
};